// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3vRIe","addWidgetButton":"Header_addWidgetButton__3lvWC","dashboardTabs":"Header_dashboardTabs__3TjXa","active":"Header_active__1ZsO1"};